import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import AuthContext from "../../context/AuthContext";
import useLoginAPI from "../../api/useLogin";
import { Toast } from "primereact/toast";
import "./Login.css";
import { useDispatch } from "react-redux";
import { goToRegister, hideDialog, setShowLoginDialog, setShowRegister } from "../../redux/dialogSlice";
import { logInUserFunc } from "../../redux/userState";

const Login: React.FC = () => {
  const basePath = process.env.REACT_APP_BASE_PATH;

  const { sendOTP, verifyOTP, saveUserAPI, generateToken } = useLoginAPI();

  const toast = useRef<Toast>(null);
  const dispatch = useDispatch();

  const { loginUser } = useContext(AuthContext) || {};
  const [username, setUsername] = useState("");
  const [OTP, setOTP] = useState("");
  const [emailError, setEmailError] = useState("");
  const [OTPError, setOTPError] = useState("");
  const [displayOTP, setDisplayOTP] = useState("");
  const [otpReceived, setOtpReceived] = useState(false);
  const [sendingOTP, setSendingOTP] = useState(false);
  const navigate = useNavigate();
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(30);

  let [authTokens, setAuthTokens] = useState(() => {
    const storedTokens = localStorage.getItem("authTokens");
    if (storedTokens === "undefined") {
      localStorage.clear();
      navigate(`${basePath}`);
    }
    return storedTokens ? JSON.parse(storedTokens) : null;
  });

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isResendDisabled && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (!countdown) {
      setIsResendDisabled(false);
      setCountdown(30);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isResendDisabled, countdown]);

  const resendOTP = (e: any) => {
    setIsResendDisabled(true);
    setOTP("");
    setDisplayOTP("");
    sendOTPFunc(e);
  };

  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const sendOTPFunc = async (e?: any) => {
    e.preventDefault();
    setOTP("");
    // setDisplayOTP("");
    // if (!validateEmail(username)) {
    //   setEmailError("Invalid email");

    //   return toast?.current?.show({
    //     severity: "error",
    //     summary: "Failed",
    //     detail: `Please enter valid email`,
    //   });
    // }
    
    setSendingOTP(true);
    // resendOTP();
    const payload = {
      username: username,
      roles: ["ROLE_CORPORATE_USER", "ROLE_CORPORATE_ADMIN", "ROLE_FLEET_OWNER", "ROLE_FLEET_USER"],
      is_for_login: true,
    };
    const response: any = await sendOTP(payload);
    if (response?.response?.status === 400) {
      // setDisplayOTP(response.otp);
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    } else if (response.status === 200) {
      setOtpReceived(true);
      setDisplayOTP(response?.data?.otp);
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `${response?.data?.message}`,
      });
    } else if (response?.response?.status === 404) {
      setOtpReceived(false);
      setDisplayOTP(response?.response?.data?.error);
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `Failed to sent OTP`,
      });
    }
  };

  const verifyOTPFunc = async (e: any) => {
    e.preventDefault();
    if (OTP === "") {
      setOTPError("Please Enter OTP");
    }
    const generateTokenPayload = {
      username: username,
      login_panel: "WEB",
      otp: OTP,
    };
    const generateTokenResponse: any = await generateToken(
      generateTokenPayload
    );
    if (
      generateTokenResponse.status === 200 ||
      generateTokenResponse.status === 201
    ) {
      setAuthTokens(generateTokenResponse?.data?.tokens);
      localStorage.setItem(
        "authTokens",
        JSON.stringify(generateTokenResponse?.data?.tokens)
      );
      dispatch(hideDialog());
      dispatch(logInUserFunc());
      dispatch(setShowLoginDialog(false));
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `${generateTokenResponse?.data?.message}`,
      });
      // navigate("/dashboard");
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${generateTokenResponse?.response?.data?.error}`,
      });
    }
  };

  const onInputChang = (e: any) => {
    setEmailError("");
    setUsername(e.target.value);
    // if (!validateEmail(e.target.value)) {
    //   setEmailError("Invalid email");
    // } else {
    //   setEmailError("");
    // }
  };

  const handleOTPInput = (e: any) => {
    setOTPError("");
    const inputOTP = e.target.value;
    const regex = /^[0-9]*$/;
    if (regex.test(inputOTP)) {
      setOTP(inputOTP);
    }
  };

  const handleRegister = () => {
    // dispatch(goToRegister());
    dispatch(setShowRegister(true)); // Show Register component
  };
  return (
    <div>
      <Toast ref={toast} />
      <div className="registration-form-wrapper">
        <div className="registration-wrapper">
          <div className="register-title">Corporate User Login</div>
        </div>
        <form>
          <div>
            <div className="p-inputgroup">
              <InputText
                id="email1"
                value={username}
                onChange={(e) => onInputChang(e)}
                placeholder="Email / Username"
                className="email-input"
              />
              <Button label="Send OTP" onClick={sendOTPFunc} />
            </div>
            {emailError && <small style={{ color: "red" }}>{emailError}</small>}
          </div>
          {/* {displayOTP && <small style={{ color: "red" }}>{displayOTP}</small>} */}
          {sendingOTP && (
            <div className="otp-wrapper">
              {/* {otpReceived && (
                <small style={{ color: "red" }}>{displayOTP}</small>
              )} */}
              {otpReceived && (
                <div>
                  <InputText
                    id="OTP"
                    type="OTP"
                    value={OTP}
                    onChange={(e) => handleOTPInput(e)}
                    className="w-full otp-input"
                    placeholder="OTP"
                    maxLength={6}
                  />
                  {OTPError && (
                    <small style={{ color: "red" }}>{OTPError}</small>
                  )}
                  <div className="resend-otp">
                    <button
                      disabled={isResendDisabled}
                      onClick={(e: any) => resendOTP(e)}
                      className={isResendDisabled ? "text-disabled" : ""}
                    >
                      Resend OTP
                    </button>
                    {isResendDisabled && <span>({countdown})</span>}
                  </div>
                </div>
              )}
              <Button
                label="Continue"
                icon="pi"
                className="w-full verify-otp-btn"
                onClick={verifyOTPFunc}
                disabled={OTP.length !== 6}
              />
            </div>
          )}

          <div className="by-continuing">
            By Continuing, You Agree To Mechmiles Terms & Conditions And Privacy
            Policy
          </div>
        </form>
      </div>
      <div className="create-account-wrapper">
        <span className="create-account-text">Don't have an account?</span>
        <a
          onClick={handleRegister}
          className="create-account-text create-account-link cursor-pointer"
        >
          Register
        </a>
      </div>
    </div>
  );
};

export default Login;
